import { axios } from "@redux/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetProductsThunk = createAsyncThunk(
  "products",
  async (data: any = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get("/v1/product", {
        headers: { "Content-Type": "application/json" },
        params: data,
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const GetForBonusProductsThunk = createAsyncThunk(
  "products-bonus",
  async (data: any = {}, { rejectWithValue }) => {
    try {
      const res = await axios.get("/v1/product", {
        headers: { "Content-Type": "application/json" },
        params: data,
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddProductsThunk = createAsyncThunk(
  "products_add",
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await axios.post("/v1/product", data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const EditProductsThunk = createAsyncThunk(
  "products_edit",
  async ({ data, id }: { data: any; id: string }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`/v1/product/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const DeleteProductsThunk = createAsyncThunk(
  "products_delete",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/v1/product/${id}`);

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const assignBonusThunk = createAsyncThunk(
  "bonus/assign",
  async ({ productId, bonusProductIds }: { productId: string; bonusProductIds: string[] }, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/v1/product/${productId}/assign-bonus`, {
        bonusProductIds,
      });
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetProductByIdThunk = createAsyncThunk(
  "products/getById",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/product/${id}`, {
        headers: { "Content-Type": "application/json" },
      });

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// **Unassign Bonus**
export const unassignBonusThunk = createAsyncThunk(
  "bonus/unassign",
  async ({ productId, bonusProductIds }: { productId: string; bonusProductIds: string[] }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`/v1/product/${productId}/unassign-bonus`, {
        bonusProductIds,
      });
      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const GetAssignedBonusesThunk = createAsyncThunk(
  "products/getAssignedBonuses",
  async ({ productId }: { productId: string }, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/v1/product/${productId}/bonus-products`);

      if (res?.data?.error) return rejectWithValue(res?.data?.error);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);